import { Dashboard } from '../../../shared/models/dashboard.model'
import { useForm } from 'react-hook-form'
import { Button, Modal } from 'react-bootstrap'
import ButtonLoading from '../../../components/button/ButtonLoading'
import DashboardForm from '../DashboardForm'
import { useAddDashboardMutation } from '../../../store/kopiliot-api/dashboard'
import { useAppSelector } from '../../../store/store'
import { Authority } from '../../../shared/models/user'
import React from 'react'

interface AddDashboardModalProps {
  isOpen: boolean
  setIsOpen: (o: boolean) => void
}

const AddDashboardModal = ({ isOpen, setIsOpen }: AddDashboardModalProps) => {
  const { currentUser } = useAppSelector((state) => state)
  const handleClose = () => {
    setIsOpen(!isOpen)
  }
  const form =
    useForm<
      Pick<
        Dashboard,
        | 'id'
        | 'name'
        | 'description'
        | 'tenantID'
        | 'image'
        | 'assignedCustomers'
      >
    >()
  React.useEffect(() => {
    form.reset({
      tenantID: currentUser?.tenantID,
    })
  }, [])
  const [addDashboard, { isLoading, error }] = useAddDashboardMutation()
  const getDisabledFields = () => {
    const disabledFields: Array<
      keyof Pick<
        Dashboard,
        | 'id'
        | 'name'
        | 'description'
        | 'tenantID'
        | 'image'
        | 'assignedCustomers'
      >
    > = ['assignedCustomers']
    if (currentUser.authority !== Authority.MAIN_TENANT) {
      disabledFields.push('tenantID')
    }
    return disabledFields
  }
  const onSubmit = async (
    data: Pick<
      Dashboard,
      'id' | 'name' | 'description' | 'tenantID' | 'image' | 'assignedCustomers'
    >
  ) => {
    try {
      await addDashboard(data).unwrap()
      handleClose()
    } catch (e) {
      console.log(e)
    }
  }
  const watch = form.watch()
  return (
    <Modal
      show={isOpen}
      centered
      onHide={handleClose}
      size={'lg'}
      className={'border'}
    >
      <Modal.Header closeButton className="border-bottom-0">
        <Modal.Title as="h5">Créer un Dashboard</Modal.Title>
      </Modal.Header>
      <Modal.Body className={'p-2'}>
        <DashboardForm
          form={form}
          disabledFields={getDisabledFields()}
          onSubmit={onSubmit}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          type={'button'}
          variant={'outline-secondary'}
          onClick={handleClose}
        >
          Annuler
        </Button>
        <ButtonLoading
          isLoading={isLoading}
          disabled={isLoading}
          type={'submit'}
          text={'Valider'}
          variant={'outline-primary'}
          onClick={form.handleSubmit(onSubmit)}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default AddDashboardModal
